<template>
  <div>
    <div class="mt-4 mb-3 d-flex align-items-center justify-content-between">
      <div>
        <h1 class="page-title">{{
            !(this.$store.getters.username === "maintenance-aprilyos@bleu122.com" && this.$store.getters.isAdmin) ? $t('dashboard.users.title') : $t('dashboard.users.title.admin')
          }}</h1>
      </div>
      <b-button variant="primary" v-on:click="clickOnCreateBtn()">
        {{ $t('Add') }}
      </b-button>
    </div>

    <b-card>
      <b122-table
        ref="B122TableDashboardUsers"
        :delete-item="allowDelete"
        :edit-item="allowEdit"
        :empty-button="$t('user.emptyButton').toString()"
        :empty-text="$t('user.emptyText').toString()"
        :empty-title="$t('user.emptyTitle').toString()"
        :fields="tableFields"
        :get-b122-table-results-url="'/user/getB122TableResults'"
        :use-filters="true"
        :use-pagination="true"
        identifier="B122TableDashboardUsers"
        init-b122-table-url="/user/initB122Table"
        @add="clickOnCreateBtn"
        @clickOnDeleteBtn="clickOnDeleteBtn"
        @clickOnEditBtn="clickOnEditBtn"
        @clickOnShowBtn="clickOnShowBtn"
        @setTotalCount="setTotalCount">

        <template #cell(subscriptionType)="row">
          <div v-if="row.item.subscriptionType == 'COLLABORATOR'">
            {{ $t(row.item.role) }}
          </div>
          <div v-else>
            {{ $t('user.Payment.' + row.item.subscriptionType) }}
          </div>
        </template>

        <template #cell(subscriptionStatus)="row">
          {{ $t('subscription.status.' + row.item.subscriptionStatus) }}
        </template>

        <template #cell(username)="row">
          <div>
            <div>{{ splitEmail(row.item.username).username }}</div>
            <div>@{{ splitEmail(row.item.username).domain }}</div>
          </div>
        </template>

        <template #cell(entreprise)="row">
          <div style="max-width: 120px">{{ $t(row.item.entreprise) }}</div>
        </template>

        <template #cell(actions)="row">
          <div class="actions-container text-right">
            <button v-if="$store.getters.username==('maintenance-aprilyos@bleu122.com')&&$store.getters.isAdmin"
                    class="impersonate-btn mr-1"
                    @click="impersonate(row)">
              <user-icon size="18"/>
            </button>
            <button v-if="$store.getters.isAdmin" class="show-action-btn edit mr-1" @click="clickOnEditBtn(row)">
              <pencil-icon size="18"/>
            </button>
            <button v-if="$store.getters.isAdmin" class="show-action-btn delete" @click="clickOnDeleteBtn(row)">
              <trash-icon size="18"/>
            </button>
          </div>
        </template>
      </b122-table>
    </b-card>

    <Item-delete-modal
      id="user-delete-modal"
      :beginsWithVoyel="false"
      :isFeminine="false"
      :selectedItem="selectedUser"
      controllerName="user"
      itemSingularName="client"
      itemSingularNameUpp="Client"
      @didDeleteItem="didDeleteUser()">
    </Item-delete-modal>
  </div>
</template>


<script>

import B122Table from "../../../components/b122/B122Table";
import ItemDeleteModal from "../../../components/b122/ItemDeleteModal";
import api from "../../../services/api";
import TokenService from "../../../services/tokenService";
import {bus} from "../../../main";
import {mapActions} from "vuex";

export default {
  name: "DashboardUsersComponent",

  components: {
    B122Table,
    ItemDeleteModal
  },

  props: {
    operationId: {
      default: null
    }
  },

  data() {
    return {
      totalCount: 0,

      allowCreate: this.$store.getters.isAdmin,
      allowEdit: this.$store.getters.isAdmin,
      allowDelete: this.$store.getters.isAdmin,

      selectedUser: null
    }
  },

  computed: {
    tableFields() {
      return [
        {
          label: this.$i18n.t('Show'),
          key: 'show',
          sortable: false
        },
        {
          label: this.$i18n.t('user.Firstname'),
          key: 'firstname',
          sortable: true
        },
        {
          label: this.$i18n.t('user.Lastname'),
          key: 'lastname',
          sortable: true
        },
        {
          label: this.$i18n.t('user.Username'),
          key: 'username',
          sortable: true
        },
        {
          label: this.$i18n.t('user.Entreprise'),
          key: 'entreprise',
          sortable: true
        },
        {
          label: this.$i18n.t('user.Operations'),
          key: 'nbOperations',
          sortable: false
        },
        {
          label: this.$i18n.t('user.Payment'),
          key: 'subscriptionType',
          sortable: true
        },
        {
          label: this.$i18n.t('user.Subscription'),
          key: 'subscriptionStatus',
          sortable: false
        },
        {
          label: '',
          key: 'actions'
        }
      ]
    }
  },

  async mounted() {
  },

  methods: {
    ...mapActions(["setImpersonateMode"]),

    setTotalCount(totalCount) {
      this.totalCount = totalCount;
    },

    splitEmail(email) {
      if (email) {
        const parts = email.split('@');
        return {username: parts[0], domain: parts[1]};
      }
      return {username: '', domain: ''};
    },

    clickOnCreateBtn() {
      this.$router.push({
        name: 'UserCreate'
      });
    },

    clickOnShowBtn(row) {
      this.$router.push({
        name: 'UserShow',
        params: {
          userId: row.item.id
        }
      });
    },

    clickOnEditBtn(row) {
      this.$router.push({
        name: 'UserEdit',
        params: {
          userId: row.item.id
        }
      });
    },

    clickOnDeleteBtn(row) {
      this.selectedUser = row.item;
      this.$bvModal.show('user-delete-modal');
    },

    didDeleteUser() {
      this.selectedUser = null;
      this.$refs.B122TableDashboardUsers.refreshTable();
    },

    impersonate(row) {
      bus.$emit("changingImpersonate");

      let data = new FormData();
      data.append('username', row.item.username);
      api({
        method: 'POST',
        url: `user/impersonate`,
        data: data
      })
        .then((response) => {
          TokenService.addImpersonate(response.data.impersonateToken);
          this.setImpersonateMode(response.data);
          if(response.data.roles && response.data.roles.includes("ROLE_AGENT_IMMO")) {
            this.$router.push({
              name: 'DashboardAgentImmo'
            });
          } else {
            this.$router.push({
              name: 'Dashboard',
            });
          }
        });
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/dashboard/components/DashboardUsersComponent.vue